export default __webpack_public_path__ + "c04091f884afd07e0a99bd630e505042.jpg";